import { Result } from '@empathy/search-types';
import { NoResultsState } from '../../../models';
import { Dictionary } from '../../../utils';
import { NO_RESULTS_MUTATIONS_KEYS } from '../no-results.const';
import { NoResultsMutation } from '../no-results.interfaces';

export class SetFallbackFiltersResultsMutation implements NoResultsMutation {
  mutations = {
    [NO_RESULTS_MUTATIONS_KEYS.clearFallbackFiltersResults]: (noResultsState: NoResultsState) => {
      noResultsState.fallbackFiltersResults = {};
    },
    [NO_RESULTS_MUTATIONS_KEYS.setFallbackFiltersResults]: (noResultsState: NoResultsState, results: Dictionary<Result>) => {
      noResultsState.fallbackFiltersResults = Object.assign({}, noResultsState.fallbackFiltersResults, results);
    }
  };
}
